export default {
  tipsOne:
    '1. Conserveremo la merce gratuitamente per 90 giorni. Se non invii il pacco o non intraprendi alcuna azione dopo 90 giorni, ciò sarà considerato un abbandono della merce e la distruggeremo in modo uniforme.',
  tipsTwo:
    "2. La merce è stata depositata in magazzino, puoi accedere al mio magazzino in qualsiasi momento e inviare il tuo indirizzo di spedizione all'estero",
  orderDetail: "Dettaglio dell'ordine",
  orderNo: 'N. ordine',
  orderConsult: 'Consultazione ordine',
  consult: 'Richiesta',
  orderConsultTips:
    "L'agente d'acquisto può gestire solo questioni relative a questo ordine. Per altre richieste, si prega di contattare",
  enquiryReplyMsg:
    'Inserisci qui, ti risponderemo entro 24 ore. (Nota: Potremmo utilizzare un software di traduzione per rispondere, che potrebbe non trasmettere fedelmente il significato, speriamo nella tua comprensione)',
  stepListEnum: {
    '-1': 'Seleziona i prodotti',
    0: 'Invia il pacco',
    6: 'Paga il trasporto',
    9: 'Spedisci il pacco',
    20: 'Conferma la ricezione',
  },
}
